module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/ten.fcded3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/ten.jpg
// module id = dYvb
// module chunks = 0